import { Icon } from '@chakra-ui/react';

export default function SFClockCheckBadgeIcon(props) {
  return (
    <Icon
      width='19px'
      height='17px'
      viewBox='0 0 19 17'
      fill='currentColor'
      {...props}
    >
      <path d='M14.945 16.414a3.984 3.984 0 0 1-3.968-3.969c0-2.172 1.796-3.968 3.968-3.968a3.984 3.984 0 0 1 3.97 3.968c0 2.172-1.813 3.97-3.97 3.97m-.476-1.828a.51.51 0 0 0 .414-.188l2.265-3.148a.5.5 0 0 0 .11-.297.49.49 0 0 0-.492-.484.48.48 0 0 0-.407.219l-1.906 2.64-.96-1.039a.53.53 0 0 0-.376-.164.48.48 0 0 0-.484.492c0 .11.031.25.125.352l1.32 1.453c.102.11.266.164.39.164' />
      <path d='M8 16.328c-4.36 0-7.969-3.617-7.969-7.969C.031 4 3.633.391 7.992.391c4.063 0 7.485 3.148 7.922 7.117a4.4 4.4 0 0 0-1.351-.063 6.62 6.62 0 0 0-6.57-5.726 6.6 6.6 0 0 0-6.626 6.64A6.61 6.61 0 0 0 8 15a6.5 6.5 0 0 0 2.39-.453c.188.406.422.789.72 1.133a7.7 7.7 0 0 1-3.11.648M3.906 9.203a.53.53 0 0 1-.539-.547.53.53 0 0 1 .54-.539h3.546V3.391a.53.53 0 0 1 .54-.54c.304 0 .546.235.546.54v5.265a.54.54 0 0 1-.547.547z' />
    </Icon>
  );
}
